import React from 'react';
import PlayersRosterTable from '../PlayersRosterTable';
import { apiURL, d3PlayersByClubAPI } from "../../../shared/api/variables";
import { useQuery } from 'react-query';
import { fetchClient } from '../../../shared/api/fetching';

const PlayersRosterTableWrapper = ({ linkRulePath, clubOptaId }) => {
  const { data: players } = useQuery({
    queryKey: [`mls-clubs-players-hub-roster`, { clubOptaId }],
    queryFn: () => fetchClient({ endpoint: d3PlayersByClubAPI({ clubOptaId }), apiURL: apiURL.d3SportsAPI }),
    select: (playersData) => {
      return playersData.map((playerData) => {
        if (playerData.playerSlug && linkRulePath) {
          playerData.playerUrl = linkRulePath.replace("{slug}", playerData.playerSlug);
        } else {
          playerData.playerUrl = null;
        }

        return playerData;
      });
    }
  });

  return (
    <>
      {players ?
        <div role="region" className="mls-c-active-roster">
          <PlayersRosterTable
            baseClass={"mls-c-active-roster"}
            playersData={players}
            emptyResultsComponent={
              <></>
            }
          />
        </div>
        : <></>
      }
    </>
  );
};

export default PlayersRosterTableWrapper;
